module.exports = __webpack_public_path__ + "img/menu-icon-close.6a64343e.svg";